<script lang="ts" setup>
import { digitsEnToFa } from "@persian-tools/persian-tools"
import moment from "jalali-moment"
import { useBlockingOnce } from "~/composables/local/once"
import BlogPagination from "../../../components/website/blog/BlogPagination.vue"

definePageMeta({
	layout: "website",
})

useHead({
	title: "هوش مصنوعی Tuka | بلاگ و اخبار هوش مصنوعی",
})

const gql = useGql()
const config = useRuntimeConfig()

const totalCount = useState<number>("total-blog-count")
const posts = useState<Awaited<ReturnType<typeof getBlogs>>>("blog-posts", () => [])
const firstBlogItem = computed(() => posts.value.at(0))

posts.value = await useBlockingOnce(() => getBlogs(0, 10))

async function getBlogs(start: number, limit: number) {
	const data = await fetch(`${config.public.strapi.address}/api/blogs?pagination[start]=0&pagination[limit]=0`)
	const jsonData = await data.json()

	totalCount.value = jsonData?.meta?.pagination?.total || 0
	const { blogs } = await gql.query({
		blogs: [{
			sort: ["createdAt:DESC"],
			pagination: {
				start,
				limit,
			},
		}, {
			documentId: true,
			title: true,
			slug: true,
			createdAt: true,
			category: {
				name: true,
			},
			image: {
				url: true,
			},
			writer: {
				name: true,
				image: {
					url: true,
				},
			},
		}],
	})

	return blogs.map(item => ({
		...item,
		createdAt: item.createdAt ? digitsEnToFa(moment(item.createdAt!).locale("fa").format("jD jMMM jYYYY")) : "",
	}))
}

async function pagination(page: number) {
	posts.value = await getBlogs(page * 1, 10)
}
</script>

<template>
	<section class="relative pt-4">
		<BlogHero
			v-if="firstBlogItem"
			class="z-1 hidden lg:flex"
			:title="firstBlogItem.title"
			:category="firstBlogItem.category?.name"
			:slug="firstBlogItem.slug"
			:date="firstBlogItem.createdAt"
			:image-src="`${config.public.strapi.address}${firstBlogItem.image?.url}`"
			:writer="firstBlogItem.writer?.name"
			:profile-pic="`${config.public.strapi.address}${firstBlogItem.writer?.image}`" />

		<div class="relative z-1 flex flex-col items-center justify-center pb-35 pt-8 container lg:pt-24">
			<LandingTitle class="mb-12">
				<template #title>
					آخرین پست ها
				</template>

				<template #description>
					با اپلیکیشن بیشتر آشنا شو و ببین که چه کار هایی از دستش بر میاد !
				</template>
			</LandingTitle>

			<div class="grid gap-8 container lg:grid-cols-3 md:grid-cols-2">
				<BlogCard
					v-for="item in posts"
					:key="item.documentId"
					class="lg:first:hidden"
					:writer="item.writer?.name"
					:slug="item.slug"
					:profile-pic="`${config.public.strapi.address}${item.writer?.image?.url}`"
					:category="item.category?.name"
					:date="item.createdAt"
					:image-src="`${config.public.strapi.address}${item.image?.url}`"
					:title="item.title" />
			</div>

			<div class="mt-12 flex items-center justify-center">
				<BlogPagination
					:total-count="totalCount"
					@page="pagination" />
			</div>
		</div>

		<CtaSection />

		<NuxtImg
			src="/website/blog-decor.svg"
			width="75"
			height="138"
			class="absolute end-0 top-1/2 hidden lg:block" />

		<NuxtImg
			src="/website/blog-decor.svg"
			width="75"
			height="138"
			class="absolute start-0 top-1/3 hidden lg:block" />
	</section>
</template>
